<template>
  <div class="custom-tree-container">
    <div class="block">
      <el-button
        size="mini"
        type="primary"
        @click="addTitle"
        icon="el-icon-plus"
        >新增导航</el-button
      >

      <el-tree
        style="padding: 20px"
        :data="TableData"
        show-checkbox
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span><i :class="data.icon_url"></i> {{data.name }}</span>
          <span>
            <el-button
              v-if="data.type == '1'"
              type="text"
              size="mini"
              @click="() => append(data)"
            >
              + 节点
            </el-button>

            <el-button type="text" size="mini" @click="() => edit(data)">
              编辑
            </el-button>

            <el-button
              type="text"
              size="mini"
              @click="() => remove(node, data)"
            >
              删除
            </el-button>
          </span>
        </span>
      </el-tree>
    </div>

    <el-dialog title="新增标题" :visible.sync="dialogVisible" width="50%">
      <el-form ref="form" :model="form" size="mini" label-position="left">
        <el-form-item label="排序号">
          <el-input-number
            v-model="form.sort"
            :precision="1"
            :step="0.1"
            :max="100"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="名称">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="router">
          <el-input v-model="form.router"></el-input>
        </el-form-item>

        <el-form-item label="图标">
          <el-input v-model="form.icon_url"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="adminCreateOrUpdateAuthPermission('1')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="新增节点" :visible.sync="dialogVisible1" width="50%">
      <el-form ref="form" :model="form" size="mini" label-position="left">
        <el-form-item label="排序号">
          <el-input-number
            v-model="form.sort"
            :precision="1"
            :step="0.1"
            :max="100"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="名称">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="router">
          <el-input v-model="form.router"></el-input>
        </el-form-item>

        <el-form-item label="图标">
          <el-input v-model="form.icon_url"></el-input>
        </el-form-item>

        <el-form-item label="子页面">
          <el-button
            round
            class="el-icon-plus"
            size="mini"
            @click="AddChildrenPage"
          ></el-button>
        </el-form-item>

        <el-form-item v-for="(item, index) of ChildPages" :key="index">
          <el-input
            size="mini"
            style="width: 200px"
            v-model="form.childpages[index]"
          ></el-input>
          <span
            style="margin-left: 20px"
            class="el-icon-remove-outline"
            @click="DeleteChildrenPage(index)"
          ></span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible1 = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="adminCreateOrUpdateAuthPermission('2')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminCreateOrUpdateAuthPermission,
  adminGetAuthPermissionList,
  adminDeleteAuthPermission,
} from "@/api/admin";

export default {
  name: "sysset-nav",
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      form: {
        id: "",
        level: "",
        sort: "",
        title: "",
        router: "",
        father_permission_id: "",
        icon_url: "",
        childpages: [],
      },
      TableData: [],

      ChildPages: [],
      auth_permission_id:""
    };
  },
  mounted() {
    this.adminGetAuthPermissionList();
  },

  methods: {
    //删除标题

    adminDeleteAuthPermission(id) {
      console.log("删除标题");

      this.$confirm("确定删除标题吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adminDeleteAuthPermission({
          auth_permission_id: id,
        }).then((res) => {
          console.log("删除标题");
          console.log(res);
          if (res.is_delete) {
            this.$message.success("删除成功");
            this.adminGetAuthPermissionList();
          }
        });
      });
    },

    //查询标题列表
    adminGetAuthPermissionList() {
      adminGetAuthPermissionList().then((res) => {
        console.log("查询标题列表");
        console.log(res);
        this.TableData = res.firstLevelPermissionList;
      });
    },

    addTitle() {
      this.dialogVisible = true;
      this.auth_permission_id = null;

      this.form = {
        id: "",
        level: "",
        sort: "",
        title: "",
        router: "",
        father_permission_id: "",
        icon_url: "",
      };
    },

    adminCreateOrUpdateAuthPermission(cmd) {
      console.log("提交的参数");
      console.log("cmd");
      console.log(cmd);

      console.log(this.form);

      if (cmd == "1") {
        console.log("新增一级标题");

        if (!this.form.id) {
          adminCreateOrUpdateAuthPermission({
            sort_num: this.form.sort,
            type: 1,
            name: this.form.title,
            permission_key: this.form.router,
            icon_url: this.form.icon_url,
          }).then((res) => {
            console.log("创建导航标题");
            console.log(res);
            if (res.is_create) {
              this.$message.success("创建成功");

              (this.form = {
                id: "",
                level: "",
                sort: "",
                title: "",
                router: "",
                father_permission_id: "",
                icon_url: "",
              }),
                (this.dialogVisible = false);
              this.adminGetAuthPermissionList();
            }
          });
        } else {
          adminCreateOrUpdateAuthPermission({
            sort_num: this.form.sort,
            type: 1,
            name: this.form.title,
            permission_key: this.form.router,
            auth_permission_id: this.form.id,
            icon_url: this.form.icon_url,
          }).then((res) => {
            console.log("更新标题成功");
            console.log(res);
            if (res.is_update||res.is_create) {
              this.$message.success("更新成功");
              this.dialogVisible1 = false;

              (this.form = {
                id: "",
                level: "",
                sort: "",
                title: "",
                router: "",
                father_permission_id: "",
                icon_url: "",
              }),
                (this.dialogVisible = false);
              this.adminGetAuthPermissionList();
            }
          });
        }
      } else if (cmd == "2") {
        if (!this.form.id) {
          console.log("新增子标题");
          adminCreateOrUpdateAuthPermission({
            sort_num: this.form.sort,
            type: 2,
            name: this.form.title,
            permission_key: this.form.router,
            father_permission_id: this.form.father_permission_id,
            icon_url: this.form.icon_url,
            children_permission_key: JSON.stringify(this.form.childpages),
          }).then((res) => {
            console.log("创建节点成功");
            console.log(res);
            if (res.is_create) {
              this.$message.success("创建成功");

              this.dialogVisible1 = false;

              (this.form = {
                id: "",
                level: "",
                sort: "",
                title: "",
                router: "",
                father_permission_id: "",
                icon_url: "",
                childpages: [],
              }),
                this.adminGetAuthPermissionList();
            }
          });
        } else {
          adminCreateOrUpdateAuthPermission({
            sort_num: this.form.sort,
            type: 2,
            name: this.form.title,
            permission_key: this.form.router,
            father_permission_id: this.form.father_permission_id,
            auth_permission_id: this.form.id,
            icon_url: this.form.icon_url,
            children_permission_key: JSON.stringify(this.form.childpages),
          }).then((res) => {
            console.log("更新子标题");
            console.log(res);
            if (res.is_update) {
              this.$message.success("更新成功");

              this.dialogVisible1 = false;

              (this.form = {
                id: "",
                level: "",
                sort: "",
                title: "",
                router: "",
                father_permission_id: "",
                icon_url: "",
                childpages: [],
              }),
                this.adminGetAuthPermissionList();
            }
          });
        }
      }
    },

    append(data) {
      console.log("新增节点");
      console.log(data);
      this.dialogVisible1 = true;
      this.form.father_permission_id = data.id;
    },

    edit(data) {
      console.log("编辑标题");
      console.log(data);
      if (data.type == "1") {
        this.dialogVisible = true;

      } else if (data.type == "2") {
        this.dialogVisible1 = true;
      }
      this.form.id = data.id;
      this.form.level = data.type.toString();
      this.form.sort = data.sort_num;
      this.form.title = data.name;
      this.form.router = data.permission_key;
      this.form.father_permission_id = data.father_permission_id;
      this.form.icon_url = data.icon_url;
      this.form.childpages = data.childrenPermissionKeyArr;
      this.ChildPages = data.childrenPermissionKeyArr;
    },

    remove(node, data) {
      console.log(node);
      console.log(data);

      this.adminDeleteAuthPermission(data.id);
    },
    //新增子页面
    AddChildrenPage() {
      console.log("新增子页面");
      this.ChildPages.push("");

      console.log(this.form.childpages);
    },

    DeleteChildrenPage(index) {
      console.log("删除子页面");
      this.ChildPages.splice(index, 1);
      this.form.childpages.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-tree-container {
  margin: 10px;

  .block {
    background: #fff;
    padding: 20px;
    border-radius: 5px;

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 20px;
    }
  }
}
</style>